import { benefits } from "@/lib/siteData";
import { Reveal } from "./Primitives";

export const Benefits = () => (
  <section id="beneficios" className="relative mx-auto max-w-7xl px-4 py-24 md:px-8 md:py-32">
    <Reveal className="mb-14 max-w-2xl">
      <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-cyan-400">// Por que a NovaStream</span>
      <h2 className="mt-4 font-display text-3xl font-black uppercase leading-tight tracking-tighter md:text-5xl">
        Tudo que você precisa para assistir sem limites
      </h2>
    </Reveal>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {benefits.map((b, i) => {
        const Icon = b.icon;
        return (
          <Reveal key={b.title} delay={i * 0.06} className={b.span || ""}>
            <div
              data-testid={`benefit-card-${i}`}
              className={`group h-full rounded-3xl border p-8 transition-transform duration-300 hover:-translate-y-2 ${
                b.highlight
                  ? "border-[#8B5CF6]/60 bg-gradient-to-br from-[#8B5CF6]/15 to-transparent glow-purple"
                  : "border-white/5 bg-gradient-to-br from-[#0F0F1A] to-[#05050A]"
              }`}
            >
              <div className={`mb-6 inline-flex rounded-2xl p-3 ${b.highlight ? "bg-[#8B5CF6]/20" : "bg-white/5"}`}>
                <Icon className={`h-7 w-7 ${b.highlight ? "text-[#a78bfa]" : "text-[#06B6D4]"}`} />
              </div>
              <h3 className="font-display text-xl font-bold tracking-tight md:text-2xl">{b.title}</h3>
              <p className="mt-3 font-body text-slate-400">{b.desc}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
